import { apiClient } from '@slot-nx/core'
import { BetDetailResponse } from './betDetailResponse'
import { gameConfig } from '../../../config'

export declare interface IOpBetDetailApi {
  getOpBetDetail: (payload: string, time: string) => Promise<BetDetailResponse>
}
export const opBetDetailApi: IOpBetDetailApi = {
  async getOpBetDetail(payload: string, time: string): Promise<BetDetailResponse> {
    const res = await apiClient.get<BetDetailResponse>(`${gameConfig.name}/operator/betdetail`, {
      params: {
        payload,
        time,
      },
    })
    return res.data
  },
}
